<script lang="ts">
	import Overlay from '../components/overlay.svelte';
	import BtnIcon from '$lib/buttons/v2/btnIcon.svelte';
	import Plus from '$lib/icons/plus.svelte';
	import { editable } from '../editable';
	import type { ISbStoryData } from '@storyblok/js';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			overlay_blocks: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();

	let overlay = $state<{ show: () => void }>();
</script>

<div use:editable={content}>
	<BtnIcon
		title="open overlay"
		size="little"
		theme="stone/lime-green"
		onclick={() => overlay?.show()}><Plus class="h-[18px] w-[18px]" /></BtnIcon
	>

	{#if content.overlay_blocks?.length > 0}
		<Overlay bind:this={overlay}>
			{#each content.overlay_blocks as overlayBlock}
				<Blok content={overlayBlock} />
			{/each}
		</Overlay>
	{/if}
</div>
